import { useRef, useState, useEffect } from "react";
import QRCodeStyling from "@plasticprintersinc/pp-qr-code";
import { useInView } from "react-intersection-observer";

export default function RestoreQRThumbnail({ qrData, size = 75 }) {
    const qrRef = useRef(null);
    const { ref, inView } = useInView({
        threshold: 0.1,
        triggerOnce: true,
    });

    const options = {
        ...qrData?.qr_style,
        width: size,
        height: size,
    };

    const [code, setCode] = useState(inView ? new QRCodeStyling(options) : null);

    useEffect(() => {
        if (inView && !code && options) {
            setCode(() => new QRCodeStyling(options));
        } else if (inView && code && options && qrRef.current) {
            code.update(options);
            code.append(qrRef.current);
        }
    }, [inView, code, options, setCode]);

    return (
        <>
            {!code ? (
                <div ref={ref} style={{ 
                    width: "100%", 
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}>
                    <i className="fas fa-spinner fa-spin" style={{ fontSize: "0.75rem" }} />
                </div>
            ) : (
                <div ref={qrRef} />
            )}
        </>
    );
}
